export enum MarginSide {
  TOP,
  BOTTOM,
  LEFT,
  RIGHT,
}
